import type { IDocumentCostType } from '@/interfaces'

export class DocumentCostType implements IDocumentCostType {
	code: string | null
	name: string | null

	constructor({ code = null, name = null }: Partial<IDocumentCostType> = {}) {
		this.code = code
		this.name = name
	}
}
